/** Provider-level background config — intentionally simpler than the Redux SelectedVirtualBackground type. */
export interface BackgroundConfig {
  type: string;
  value: string;
}

export interface ActivateBackgroundOptions {
  type: string;
  value: string;
  stream: MediaStream;
}

export interface InputMediaOptions {
  stream: MediaStream;
  stopTracksOnDestruction?: boolean;
}

export abstract class VirtualBackgroundProvider {
  abstract get name(): string;
  abstract get activated(): boolean;
  abstract get activeBackground(): BackgroundConfig;
  abstract get initialized(): boolean;

  abstract init(): Promise<void>;
  abstract activate(options: ActivateBackgroundOptions): Promise<MediaStream | void>;
  /** Free GPU/CPU resources (sdk.destroy() without flag). ML models stay cached for fast re-init. */
  abstract deactivate(): Promise<void>;
  abstract changeBackground(config: BackgroundConfig): Promise<void>;
  abstract setInputMedia(options: InputMediaOptions): Promise<MediaStream>;
  /** Full teardown including ML models. Use on session end. Requires full re-init to resume. */
  abstract destroy(): Promise<void>;
  /** Soft reset — deactivate + clear state. SDK instance survives for re-activation (e.g. room transitions). */
  abstract reset(): void;

  /** Toggle FPS overlay (debug mode). No-op for providers that don't support it. */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this -- default no-op
  setShowFps(_show: boolean): void {}

  /** Abandon an in-flight init(). Must be safe to call outside the manager's operation lock. */
  // eslint-disable-next-line class-methods-use-this -- default no-op
  abortInit(): void {}
}
